var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchoolIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.431 15.8998H25.154V14.4945C25.1536 14.2892 25.0427 14.1 24.8638 13.9995L17.069 9.61845V7.3881H18.6109V8.23586C18.6109 8.55007 18.8656 8.80483 19.1798 8.80483H23.8283C24.1425 8.80469 24.3971 8.54986 24.397 8.23565C24.397 8.16979 24.3855 8.10443 24.3631 8.04241L23.8966 6.71672L24.3688 5.41948C24.4756 5.12398 24.3227 4.79782 24.0272 4.69099C23.9653 4.66859 23.8999 4.65714 23.834 4.65707H21.7174V3.83207C21.7174 3.51786 21.4627 3.2631 21.1484 3.2631H17.069V2.56897C17.069 2.25475 16.8142 2 16.5 2C16.1858 2 15.931 2.25475 15.931 2.56897V9.61845L8.13621 13.9938C7.95727 14.0944 7.84639 14.2835 7.84603 14.4888V15.8941H0.568965C0.254754 15.8941 0 16.1489 0 16.4631V31.3472C0 31.6615 0.254754 31.9162 0.568965 31.9162H32.431C32.7452 31.9162 33 31.6615 33 31.3472V16.4688C33 16.1546 32.7452 15.8998 32.431 15.8998ZM21.7174 6.81914L21.6947 6.79638V5.81776H22.9919L22.7586 6.54603C22.712 6.67277 22.712 6.81188 22.7586 6.93862L23.026 7.6669H19.7488V7.3881H21.1484C21.4627 7.3881 21.7174 7.13335 21.7174 6.81914ZM17.069 4.40103H20.5795V5.24879V6.25017H17.069V4.40103ZM7.84603 30.7783H1.13793V17.0378H7.84603V30.7783ZM15.931 30.7783H12.944V24.2807H15.931V30.7783ZM20.056 30.7783H17.069V24.2807H20.056V30.7783ZM24.0388 30.7783H21.194V23.7117C21.194 23.3975 20.9392 23.1428 20.625 23.1428H12.375C12.0608 23.1428 11.806 23.3975 11.806 23.7117V30.7783H8.96121V14.8472L16.5 10.6028L24.016 14.8245L24.0388 16.4631V30.7783ZM31.8621 30.7783H25.154V17.0378H31.8621V30.7783Z",
    fill: "#25A18E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4992 11.8856C15.1816 11.8887 14.1152 12.9577 14.1152 14.2753C14.1184 15.5919 15.1882 16.6567 16.5049 16.6535C17.8215 16.6504 18.8863 15.5806 18.8832 14.2639C18.88 12.9495 17.8136 11.8856 16.4992 11.8856ZM16.4992 15.5156C15.811 15.5125 15.2557 14.9521 15.2589 14.2639C15.262 13.5802 15.8154 13.0267 16.4992 13.0236C17.1883 13.0267 17.7452 13.5862 17.7452 14.2753H17.7509C17.7478 14.9634 17.1874 15.5187 16.4992 15.5156Z",
    fill: "#25A18E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64672 17.8314H2.50879V20.1073H3.64672V17.8314Z",
    fill: "#25A18E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45238 17.8314H5.31445V20.1073H6.45238V17.8314Z",
    fill: "#25A18E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9663 17.8314H10.6904V18.9694H12.9663V17.8314Z",
    fill: "#25A18E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6382 17.8314H15.3623V18.9694H17.6382V17.8314Z",
    fill: "#25A18E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3091 17.8314H20.0332V18.9694H22.3091V17.8314Z",
    fill: "#25A18E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9663 20.4828H10.6904V21.6207H12.9663V20.4828Z",
    fill: "#25A18E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6382 20.4828H15.3623V21.6207H17.6382V20.4828Z",
    fill: "#25A18E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3091 20.4828H20.0332V21.6207H22.3091V20.4828Z",
    fill: "#25A18E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64672 22.3092H2.50879V24.5851H3.64672V22.3092Z",
    fill: "#25A18E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45238 22.3092H5.31445V24.5851H6.45238V22.3092Z",
    fill: "#25A18E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64672 26.7926H2.50879V29.0685H3.64672V26.7926Z",
    fill: "#25A18E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45238 26.7926H5.31445V29.0685H6.45238V26.7926Z",
    fill: "#25A18E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6858 17.8314H26.5479V20.1073H27.6858V17.8314Z",
    fill: "#25A18E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4914 17.8314H29.3535V20.1073H30.4914V17.8314Z",
    fill: "#25A18E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6858 22.3092H26.5479V24.5851H27.6858V22.3092Z",
    fill: "#25A18E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4914 22.3092H29.3535V24.5851H30.4914V22.3092Z",
    fill: "#25A18E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6858 26.7926H26.5479V29.0685H27.6858V26.7926Z",
    fill: "#25A18E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4914 26.7926H29.3535V29.0685H30.4914V26.7926Z",
    fill: "#25A18E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolIcon);
export default __webpack_public_path__ + "static/media/SchoolIcon.a7e775ef5736df397b1347aaa4fe3ea1.svg";
export { ForwardRef as ReactComponent };